import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import "./Blog.css";

function HowWeSolveProblems() {
  return (
    <>
      <SEO />
      <motion.div
        className="blog-wrapper"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
      >
        <article className="blog-article">
          <header className="blog-header">
            <h1>Solving Complex Technical Challenges with WaveTech Solutions</h1>
            <p className="blog-meta">
              Published: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </header>

          <div className="blog-content">
            <section className="blog-section">
              <p style={{ fontSize: '1.2rem', lineHeight: '1.8', marginBottom: '2rem' }}>
                At WaveTech Solutions, we focus on solving problems, not just implementing features. We partner with online businesses to provide robust technical solutions, tailor-made to address unique challenges.
              </p>
            </section>
            
            <section className="blog-section">
              <h2>Starting with the Problem, Not the Feature</h2>
              <p>Our approach begins with understanding your business challenges. Rather than jumping into feature development, we first explore the root of the problem. This ensures that we build the right solution that truly meets your needs.</p>
            </section>
            <section className="blog-section">
              <h2>What We Build</h2>
              <p>Our expertise lies in developing Shopify solutions, web applications, automation systems, and infrastructure. We are committed to delivering high-quality, scalable, and secure solutions that drive business growth and efficiency.</p>
            </section>
            <section className="blog-section">
              <h2>Our Process: Discover, Architect, Build, Maintain</h2>
              <p>Our process involves four key stages: discover, architect, build, and maintain. We start by exploring your problem, then design a solution architecture. Next, we build your solution with meticulous attention to detail. Finally, we maintain the solution, ensuring it runs smoothly and stays updated.</p>
            </section>
            <section className="blog-section">
              <h2>Who We Work With</h2>
              <p>We are a perfect fit for online businesses looking for a technical partner to help them overcome their challenges. We work best with businesses that value a collaborative approach, clear communication, and long-term partnerships.</p>
            </section>
            <section className="blog-section">
              <h2>Fit vs. Not a Fit</h2>
              <p>We strive to work with businesses that align with our approach and values. If you are looking for a quick, one-off job or a low-cost solution, we might not be the right fit. We believe in investing time and resources to deliver sustainable, long-term solutions.</p>
            </section>
            <section className="blog-section">
              <h2>Next Steps</h2>
              <p>If you're ready to solve your technical challenges with a reliable partner, we're here to help. Visit our contact page to get in touch with us and start the conversation about your project.</p>
            </section>
            <section className="blog-section">
              <p>At WaveTech Solutions, we're more than just a service provider. We're a partner in your journey towards success. Let's work together to build solutions that drive growth and efficiency for your online business.</p>
              <p style={{ marginTop: '1rem' }}>
                <Link to="/contact" style={{ color: 'var(--accent)' }}>Contact us</Link> or read <Link to="/process" style={{ color: 'var(--accent)' }}>how we work</Link>.
              </p>
            </section>
          </div>
        </article>
      </motion.div>
    </>
  );
}

export default HowWeSolveProblems;
